import { useState, useEffect } from "react";

import { SiJavascript, SiAdobe } from "react-icons/si";
import {
  DiReact,
  DiApple,
  DiTerminal,
  DiGithubBadge,
  DiGitBranch,
  DiNodejsSmall,
  DiNpm,
  DiSass,
  DiLess,
  DiVisualstudio,
  DiIllustrator,
  DiPhotoshop,
  DiMysql,
  DiCss3,
  DiHtml5,
} from "react-icons/di";

import "./TechStack.scss";

const TechStack = () => {
  const [description, setDescription] = useState(
    "Love these design and coding tools"
  );

  const [backgroundColor, setBackgroundColor] = useState("transparent");

  const onHoverIn = (text, bgColor) => {
    setDescription(text);
    setBackgroundColor(bgColor);
  };

  const onHoverOut = () => {
    setDescription("Love these design and coding tools");
    setBackgroundColor("transparent");
  };

  const [iconList] = useState([
    {
      color: "#A2AAAD",
      description: "I love Apple products",
      iconName: <DiApple />,
    },
    {
      color: "#3a89c0",
      description: "I use VS CODE as Editor",
      iconName: <DiVisualstudio />,
    },
    {
      color: "#181717",
      description:
        "iTerm runinning/installing - dependencies & packages, running tasks etc...",
      iconName: <DiTerminal />,
    },
    {
      color: "#4078c0",
      description: "I use github for version control",
      iconName: <DiGithubBadge />,
    },
    {
      color: "#c66f40",
      description:
        "Collaboration with other using git Branches for features, Code Review and Merge",
      iconName: <DiGitBranch />,
    },
    {
      color: "#43853d",
      description: "Node, Server side & REST API",
      iconName: <DiNodejsSmall />,
    },
    {
      color: "#c72626",
      description: "Package Manager & dependencies",
      iconName: <DiNpm />,
    },
    {
      color: "#d2ab1e",
      description:
        "With javascript I do bussiness logic, DOM manipulation, http requests etc...",
      iconName: <SiJavascript />,
    },
    {
      color: "#2b87a1",
      description:
        "Love React - makes more modular component based and reactive web apps",
      iconName: <DiReact />,
    },
    {
      color: "#e34c26",
      description: "Semantic Markup and tags for SEO",
      iconName: <DiHtml5 />,
    },
    {
      color: "#2965f1",
      description:
        "I'm Passionate Pixel Perfect, Nice transitions and animations and user friendly experinces",
      iconName: <DiCss3 />,
    },
    {
      color: "#bf4080",
      description:
        "SCSS is my favorite preprocessor lang -  there are many ways to make css code more modular by using mixins, functions, loops etc..",
      iconName: <DiSass />,
    },
    {
      color: "#b9c8e0",
      description: "Sometimes I use LESS as Preprocessor language ",
      iconName: <DiLess />,
    },
    {
      color: "#8969eb",
      description: "Database Queries and Tables",
      iconName: <DiMysql />,
    },
    {
      color: "#ff3f3f",
      description: "Adobe Package",
      iconName: <SiAdobe />,
    },
    {
      color: "#ED2224",
      description: "Adobe Ilustrator",
      iconName: <DiIllustrator />,
    },
    {
      color: "#18152E",
      description: "Adobe Photoshop",
      iconName: <DiPhotoshop />,
    },
  ]);

  useEffect(() => {
    // return () => {
    //   second
    // }
    // gsap.from('.chars', {
    //   duration: 0.1,
    //   opacity: 1,
    //   // scale: 0,
    //   y: 0,
    //   // rotationX: 180,
    //   // transformOrigin: "0% 50% -50",
    //   // ease: "back",
    //   stagger: 0.01,
    // });
  }, [description]);

  return (
    <div className="section-techstack">
      <ul className="tech-stack">
        <li className="tools" style={{ backgroundColor: backgroundColor }}>
          <div className="letters">
            {description.split(" ").map((char, index) => (
              <span className="chars" key={index}>
                {char}
              </span>
            ))}
          </div>
        </li>

        {iconList.map((icon, i) => (
          <li
            onMouseEnter={() => onHoverIn(icon.description, icon.color)}
            style={{ "--hover-color": icon.color }}
            onMouseLeave={() => onHoverOut()}
            key={i}
          >
            {icon.iconName}
          </li>
        ))}

        <li
          className="more"
          style={{ "--hover-color": "#18152E" }}
          onMouseEnter={() =>
            onHoverIn(
              "Not even these - I have experience working with a lot of tools, techniques, different web programing languages, Frameworks, CMS on the internet",
              "#18152E"
            )
          }
          onMouseLeave={() => onHoverOut()}
        >
          and much more...
        </li>
      </ul>
    </div>
  );
};

export default TechStack;
